import { APIProvider } from '@vis.gl/react-google-maps'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider, OrgProvider } from '@/context'
import { Toaster } from '@/components/ui/sonner'
import { router } from './router'

const MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? ''

function App() {
  return (
    <APIProvider apiKey={MAPS_API_KEY} libraries={['places']}>
      <AuthProvider>
        <OrgProvider>
          <RouterProvider router={router} />
          <Toaster position="top-right" richColors closeButton />
        </OrgProvider>
      </AuthProvider>
    </APIProvider>
  )
}

export default App
